import { SLACK_WEB_HOOK, ADMIN_ZAPIER_HOOK, SLACK_APP_NAME, SLACK_APP_TYPE, allowSlackNotifications, SLACK_WEB_HOOK_TELERADOPS, ZAPIER_INVITE_SIGN_UP_WEB_HOOK, SLACK_WEB_HOOK_DELETE_GROUP, ZAPIER_PARTNER_PROGRAM_WEB_HOOK, ZAPIER_REQUEST_JOIN_AFFILIATE_WEB_HOOK, NONADMIN_ZAPIER_HOOK, LOCAL_STORAGE_SHARER_ID, LOCAL_STORAGE_SHARE_LINK, LOCAL_STORAGE_STUDY_ID, LOCAL_STORAGE_STUDY_GUID, LOCAL_STORAGE_USER_TYPE, LOCAL_STORAGE_SOURCE, LOCAL_STORAGE_DYNAMIC_REDIRECT_PAGE, LOCAL_STORAGE_USE_LOCALE_DROPDOWN, LOCAL_STORAGE_COUNTRY_LIST_KEY } from '../config/constants'
import { getSessionTag } from '../utils/helpers'
import store from "store"
import i18n from 'i18next'
import { getCurrentIPInfoAPICall } from './location'
import { isEmpty } from 'lodash'

const prepareNotificationPayload = (title, description, jsonContent) => {
  let notificationMessage = `>>>${getSessionTag() ? ` Session: [${getSessionTag()}]` : ""} Title: ${title}`
  notificationMessage += '\n'
  if (description) {
    notificationMessage += '\n'
    notificationMessage += description
  }
  if (jsonContent) {
    notificationMessage += '\n'
    notificationMessage += '```'
    notificationMessage += (jsonContent)
    notificationMessage += '```'
    // forEach(jsonContent, (value, key) => {
    //   notificationMessage += '\n'
    //   if (includes(phoneNumberFields, key)) {
    //     notificationMessage += key + ': ' + value.phone
    //   } else if (key === 'invitees') {
    //     notificationMessage += 'List of Invitees:'
    //     forEach(value, (childValue, childKey) => {
    //       notificationMessage += 'Invitee ' + (childKey + 1) + ': { name: ' + childValue.name + ', email: ' + childValue.email + ' }'
    //     })
    //   } else if (key === 'providerFacilities') {
    //     notificationMessage += key + 'List of Source Facilities:'
    //     forEach(value, (childValue, childKey) => {
    //       notificationMessage += 'Source Facility ' + (childKey + 1) + ': { name: ' + childValue.name + ', country: ' + childValue.country + 'phone: ' + childValue.phone && childValue.phone.phone + ', email: ' + childValue.email + ' }'
    //     })
    //   } else if (key === 'userType') {
    //     notificationMessage += 'Role of the user: ' + value.role
    //     notificationMessage += 'Type of the user: ' + value.contractType
    //   } else {
    //     notificationMessage += key + ': ' + value
    //   }
    // })
  }
  return {
    text: notificationMessage,
    username: SLACK_APP_NAME + '[ ' + SLACK_APP_TYPE + ' ]'
  }
}

export const postNotificationToSlackAPICall = async ({ title, jsonContent = null, description = null, sendToTeleradOps = false }) => {
  try {
    let responseOkByZapier

    if (!allowSlackNotifications) {
      return false
    }

    const payload = prepareNotificationPayload(title, description, jsonContent)
    const config = {
      method: 'POST',
      body: JSON.stringify(payload)
    }
    const slackResponse = await window.fetch(SLACK_WEB_HOOK_TELERADOPS, config)
    const responseOkBySlack = await slackResponse.ok

    return { responseOk: responseOkBySlack, responseOkByZapier }
  } catch (e) {
    console.error('ERROR: ', e)
  }
}

export const postNotificationToSlackForDeleteGroupAPICall = async ({ title, jsonContent = null, description = null }) => {
  try {
    let responseOkByZapier

    if (!allowSlackNotifications) {
      return false
    }

    // const payload = prepareNotificationPayload(title, description, jsonContent)
    const config = {
      method: 'POST',
      body: JSON.stringify({ headertitle: title, headerdescription: description, jsonContent })
    }
    const slackResponse = await window.fetch(SLACK_WEB_HOOK_DELETE_GROUP, config)
    const responseOkBySlack = await slackResponse.ok

    return { responseOk: responseOkBySlack, responseOkByZapier }
  } catch (e) {
    console.error('ERROR: ', e)
  }
}

const prepareCommonZapierPayload = async (jsonContent = {}, options = {}) => {
  const payload = { ...jsonContent };
  
  // Add common properties from local storage
  const userId = store.get(LOCAL_STORAGE_SHARER_ID);
  if (userId) payload.sharer_id = userId;
  const shareLink = store.get(LOCAL_STORAGE_SHARE_LINK);
  if (shareLink) payload.share_link = shareLink;
  const studyShareId = store.get(LOCAL_STORAGE_STUDY_ID);
  if (studyShareId) payload.study_share_id = studyShareId;
  const studyGuid = store.get(LOCAL_STORAGE_STUDY_GUID);
  if (studyGuid) payload.study_guid = studyGuid;
  const userType = store.get(LOCAL_STORAGE_USER_TYPE);
  if (userType) payload.user_type = userType;
  payload.locale = i18n.language;

  // Set source information
  if (options && options.source) {
    payload.group_creation_type = options.source;
  }

  const src = store.get(LOCAL_STORAGE_SOURCE);
  if (src) {
    const word = src.toLowerCase();
    const capitalizedSrc = word.charAt(0).toUpperCase() + word.slice(1);
    payload.source = capitalizedSrc;
  } else {
    payload.source = 'Clean';
    if (studyGuid || studyShareId) payload.source = 'Share';
    const redirectTo = store.get(LOCAL_STORAGE_DYNAMIC_REDIRECT_PAGE);
    if (redirectTo) payload.source = 'Community';
  }

  payload.version = process.env.REACT_APP_VERSION;

  // Add IP-derived location fields when not already present
  if (!payload.last_ip || !payload.country) {
    try {
      const ipInfo = await getCurrentIPInfoAPICall();
      if (ipInfo) {
        if (!payload.last_ip && ipInfo.ip) {
          payload.last_ip = ipInfo.ip;
        }
        if (!payload.country && ipInfo.country) {
          const countryList = store.get(LOCAL_STORAGE_COUNTRY_LIST_KEY);
          const matchedCountry = countryList && countryList.find(
            (singleCountry) => singleCountry.alpha2Code === ipInfo.country || singleCountry.alpha3Code === ipInfo.country
          );
          payload.country = matchedCountry?.name || ipInfo.country;
        }
      }
    } catch (error) {
      console.error('Error fetching IP info:', error);
    }
  }

  if (window.location.host !== 'signup.alem.health' && payload.email) payload.email = `test+${payload.email}`
  
  return payload;
};

export const postAdminSignUpInfoToZapierAPICall = async ({ jsonContent = null, options = {} }) => {
  try {
    let responseOkByZapier

    if (!allowSlackNotifications) {
      return false
    }

    if (isEmpty(jsonContent)) throw new Error(`jsonContent is required and cannot be empty${options?.source ? ` (source: ${options.source})` : ''}`)

    // Use the shared function to prepare the payload
    const payload = await prepareCommonZapierPayload(jsonContent, options)

    const config = {
      method: 'POST',
      body: JSON.stringify(payload)
    }

    const zapierResponse = await window.fetch(ADMIN_ZAPIER_HOOK, config)
    responseOkByZapier = zapierResponse.ok

    return { responseOk: responseOkByZapier }
  } catch (e) {
    console.log('ERROR: ', e)
  }
}

export const postInviteSignUpToZapierAPICall = async ({ jsonContent = null }) => {
  try {
    let responseOkByZapier

    if (!allowSlackNotifications) {
      return false
    }

    if (isEmpty(jsonContent)) throw new Error('jsonContent is required and cannot be empty')

    const config = {
      method: 'POST',
      body: JSON.stringify(jsonContent)
    }

    const zapierResponse = await window.fetch(ZAPIER_INVITE_SIGN_UP_WEB_HOOK, config)
    responseOkByZapier = await zapierResponse.ok

    return { responseOk: responseOkByZapier }
  } catch (e) {
    console.log('ERROR: ', e)
  }
}

export const postPartnerProgramNotificationToZapierAPICall = async ({ jsonContent = null }) => {
  try {
    let responseOkByZapier
    
    if (isEmpty(jsonContent)) throw new Error('jsonContent is required and cannot be empty')
    
    const config = {
      method: 'POST',
      body: JSON.stringify(jsonContent)
    }
    const zapierResponse = await window.fetch(ZAPIER_PARTNER_PROGRAM_WEB_HOOK, config)
    responseOkByZapier = await zapierResponse.ok
    return { responseOk: responseOkByZapier }
  } catch (e) {
    console.log('ERROR: ', e)
  }
}

export const postRequestAccessJoinAffiliateZapierAPICall = async (payload) => {
  try {
    let responseOkByZapier
    
    if (isEmpty(payload)) throw new Error('payload is required and cannot be empty')
    
    const config = {
      method: 'POST',
      body: JSON.stringify({...payload})
    }
    const zapierResponse = await window.fetch(ZAPIER_REQUEST_JOIN_AFFILIATE_WEB_HOOK, config)
    responseOkByZapier = await zapierResponse.ok
    return { responseOk: responseOkByZapier }
  } catch (e) {
    console.log('ERROR: ', e)
  }
}

export const postNonAdminSignUpInfoToZapierAPICall = async ({ jsonContent = null, options = {} }) => {
  try {
    let responseOkByZapier

    if (!allowSlackNotifications) {
      return false
    }

    if (isEmpty(jsonContent)) throw new Error(`jsonContent is required and cannot be empty${options?.source ? ` (source: ${options.source})` : ''}`)

    // Use the shared function to prepare the payload
    const payload = await prepareCommonZapierPayload(jsonContent, options)

    const config = {
      method: 'POST',
      body: JSON.stringify(payload)
    }

    const zapierResponse = await window.fetch(NONADMIN_ZAPIER_HOOK, config)
    responseOkByZapier = zapierResponse.ok

    return { responseOk: responseOkByZapier }
  } catch (e) {
    console.log('ERROR: ', e)
  }
}